export const inactive = { opacity: 0.2, filter: 'grayscale(100%)' };

export const awardSx = {
  maxWidth: '100px',
  textAlign: 'center',
  margin: '0px 4px 24px 4px',
};
